export enum ForgotPasswordStateEnum {
  SendEmail = 0,
  EmailIsSent = 1,
  ResetPassword = 2,
  PasswordIsReset = 3,
}
